import { assertNotEmpty } from '@festina-life/core'

import { useTemplateContext } from '../../context/templateContext'

export const useFieldPathOnCurrentTemplate = (fieldPath: string) => {
  const { templateVersion } = useTemplateContext()
  assertNotEmpty(templateVersion)

  // TODO: Currently the language server uses an old notation for frame paths that will
  //   need to be replaced with the new one (frame.range and frame.enum). This will be done
  //   as part of https://festinafinance.atlassian.net/browse/LIFE-5770
  const fieldPathWithLanguageServerFramePaths = fieldPath
    .replace(/frame\.range$/, 'rangedFrame')
    .replace(/frame\.entries$/, 'enumeratedFrame')

  /* For inherited fields the path sent to the language service must currespond with a path on current template.
   * Since, in flattned mode, inherited fields contain the path in the originating template, we need to make sure
   * to replace the template Identifier with the identifier of the current template version. */
  return fieldPathWithLanguageServerFramePaths.startsWith(
    `{${templateVersion.versionInfo.identifier}}`,
  )
    ? fieldPathWithLanguageServerFramePaths
    : `{${templateVersion.versionInfo.identifier}}${fieldPathWithLanguageServerFramePaths.substring(fieldPathWithLanguageServerFramePaths.indexOf('}') + 1)}`
}
